module.exports = __webpack_public_path__ + "img/PS5.b74dc9cf.png";